import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MdOutlineCancel } from "react-icons/md";

import ConfirmationModal from "../../Dialogs/ConfirmationModal";
import { Color } from "../../Form/Button";
import useStyles from "./styles";

export interface CancelBookingConfirmationModalHandles {
  open: (id: number, bookingNumber?: string) => void;
  close: () => void;
}
interface CancelBookingConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: (id: number) => void;
  loadingAction?: boolean;
}

const CancelBookingConfirmationModal: ForwardRefRenderFunction<
  CancelBookingConfirmationModalHandles,
  CancelBookingConfirmationModalProps
> = (props, ref) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { closeModal, loadingAction, onSubmit } = props;

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [idValue, setIdValue] = useState<number>(0);
  const [bookingNumberValue, setBookingNumberValue] = useState("");
  const open = useCallback((id: number, bookingNumber?: string) => {
    if (id) setIdValue(id);
    if (bookingNumber) setBookingNumberValue(bookingNumber);
    setOpenModal(true);
  }, []);
  const close = useCallback(() => {
    setOpenModal(false);
    setIdValue(0);
    setBookingNumberValue("");
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <ConfirmationModal
      width="520px !important"
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
      }}
      type="error"
      title={translate("cancelBooking")}
      leftIconTitle={<MdOutlineCancel color="#F04438" size={20} />}
      loading={loadingAction}
      cancelDisabled={loadingAction}
      customColorCancel={Color.TEXT_INFO}
      customColorSave={Color.ERROR}
      textCancel={translate("noThanks")}
      textSubmit={translate("cancelBooking")}
      submit={() => onSubmit(idValue)}
    >
      <Grid container spacing={2} className="mt-2">
        <Grid item className={classes.cancelModalContainer}>
          <div data-cy="confirmationModalCancelBody" className={classes.descriptionModalConfirm}>
            <span>
              {translate("areYouSureYouWantToCancelTheBooking")} {`${bookingNumberValue}`}?
            </span>
            <span className="error">{translate("thisActionIsPermanentAndCannotBeUndone")}</span>
          </div>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(CancelBookingConfirmationModal);
